import {
  MISC_LIST,
  MISC_LIST_NEW,
} from "@components/Modules/HeaderNew/headerMenuConstants";
import { HeaderMenuList } from "@components/Modules/HeaderNew/HeaderMenuList";
import { ENABLE_NEW_HEADER_FOOTER } from "@helper/getEnvVariables";
import type { ReactElement } from "react";
import { MouseEventHandler } from "react";

export type MiscLinksProps = Readonly<{
  testId?: string;
  mySPHClickHandler?: MouseEventHandler<HTMLButtonElement>;
}>;

export function MiscLinks({
  testId = "desktop-misc-links",
}: MiscLinksProps): ReactElement {
  const MenuList = ENABLE_NEW_HEADER_FOOTER ? MISC_LIST_NEW : MISC_LIST;
  return <HeaderMenuList testId={testId} items={MenuList} type="misc" />;
}
